export default {
  mediaSpendByChannel: 'Media Spend by Channel',
  dataView: 'Data View',
  close: 'Close',
  refresh: 'Refresh',
  saveAsImage: 'Save as Image'
}
